import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import ServiceCategoryIcon from '@/modules/employee/EnrollmentDetails/EnrollmentDetailsAccountInfo/EligibleServices/ServiceCategoryIcon';
import colors from '@/styles/colors';

import { CATEGORY_LABELS } from '../../../Services.constants';
import { CategoryTypeDto } from '../../../Services.types';

const useCategoryOptions = () => {
  const options = useMemo(
    () =>
      Object.entries(CATEGORY_LABELS).map(([key, value]) => ({
        key,
        value,
        title: (
          <Box direction="row" align="center" gap="spacing8">
            <ServiceCategoryIcon
              type={key as CategoryTypeDto}
              color={colors.activity[key as CategoryTypeDto]}
              size="24px"
            />
            {value}
          </Box>
        ),
      })),
    []
  );

  return options;
};

export default useCategoryOptions;
